import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  timeText: {
    fontSize: '12px',
    fontWeight: 400,
    textAlign: 'left',
    lineHeight: '20px',
    color: '#565656'
  },
  dateText: {
    fontSize: '14px',
    textTransform: 'none',
    textAlign: 'left',
    lineHeight: '20px',
    fontWeight: 500,
    color: '#565656'
  },
  titleText: {
    textAlign: 'left',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#000000',
    fontWeight: 500,
    overflow: 'hidden',
    textTransform: 'none',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    '@media (min-width: 1200px)': {
      fontSize: '16px'
    }
  },
  textBox: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: '5px',
    marginTop: '5px',
    padding: '0 16px'
  },
  statusBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '24px',
    borderRadius: '20px',
    padding: '0 12px',
    backgroundColor: '#4A4E69',
    border: '1px solid #DBDCE8'
  },
  statusText: {
    fontSize: '14px',
    fontWeight: '500',
    letter: '0.1 px',
    textTransform: 'capitalize',
  },
  eventCardBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '308px',
    height: '160px',
    border: '2px solid #F3F3F7',
    borderRadius: '16px',
    padding: '0',
  },
  dryRunCardBox: {
    width: '258px',
    height: '152px',
    marginTop: '4px',
    backgroundColor: '#F3F3F7'
  } 
}); 